import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSort } from '@btime/react-contexts'
import React from 'react'

import { exportsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useExportsState = () => React.useContext(Context) || {}
export const useExports = () => useExportsState()?.exports || []

const QUERY = gql`
  query Exports($page: Int, $sort: ExportSort, $filter: ExportFilter) {
    exports(page: $page, sort: $sort, filter: $filter) {
      id
      entity
      status
      insertedAt
      oldDocument
      document {
        id
        src
      }
      createdBy {
        id
        name
      }
    }
  }
`

const ExportsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const entity = useModalData()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { ...filter, entities: entity }
    },
    flexiblePollInterval: 10000,
    client: exportsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default ExportsLoader
